import { Pipe, PipeTransform } from "@angular/core";
import { parseMarkup } from "@app2/util/markup-utils";

@Pipe({ name: "parseMarkup" })
export class ParseMarkupPipe implements PipeTransform {
    transform(input: string): string {
        if (!input) {
            return "";
        }
        return parseMarkup(input);
    }
}
